import type { TenantConfig } from '@/types/index';

/**
 * Default fallback tenant config.
 * Loaded when no tenant-specific config matches the current subdomain.
 *
 * Per spec §7 multi-tenant subdomain pattern: `{tenant}.reports.claridynamics.com`.
 * Per Reporting_v4_Spec.md §8 Rev 4: tenant_type controls demo_operator RBAC.
 */
export const defaultTenant: TenantConfig = {
  tenantId: '_default',
  tenantName: 'ClariDynamics',
  tenantType: 'demo',
  programs: [],
  brandTokens: {
    primaryHex: '#2563eb',
    accentHex: '#7c3aed',
    logoUrl: '/branding/_default/logo.svg',
    fontFamily: "'Inter Variable', Inter, system-ui, sans-serif",
  },
  freshness: { kind: 'fresh', snapshotDate: new Date().toISOString().slice(0, 10) },
};
